/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");

require('components/common/table-data/table-data');
const { inputBox: inputBoxEvent, dropMenu: dropMenuEvent } = require('components/config/event.json');
const tip = require('components/base/pop/tip');
const pop = require('components/base/pop/pop');
const appConfig = require('rootPath/config/app/appBackend.json');


const ajaxHttp = require('appUtil/ajaxHttp');
const { apiPath } = require('appService/api');
const store = require('appVuex/store');
const { setBreadCrumb } = require('src/common/vuex/action/common');
const communityMixin = require('../../community/communityMixin');
const template = require('./apply-list.tpl');

require('./apply-list.scss');

const ChargerComment = {
	mixins: [communityMixin],
	template,
	store,
	vuex: {
		actions: {
			setBreadCrumb,
		}
	},

	data() {
		return {
			thItems: ["用户ID","用户名","收件人","联系电话","收货地址","报名时间","备注信息"],
			url: apiPath.community.applyList,
			exportUrl:apiPath.community.exportActive,
			pageInitCt: 1,
			
			placeItem:"按用户ID搜索",
			searchList: [
				{value:"userId", text:"按用户ID"},
				{value:"userName", text:"按用户名"}
			],
			searchName:"userId",
			searchVal: "",
			activityId:this.$route.params.id,
			queryOpt:{'activityId':this.$route.params.id}
		}
	},
	ready(){
		
	},
	methods:{

		searchData(){
			this.$refs.tableData.query({
				"activityId": this.activityId,
				"searchName":this.searchName,
				"searchVal":this.searchVal
			}).fetch();
		},
		exportActi(){

			var prodUri = document.domain.indexOf('app.admin.evclub.com') == -1 ? appConfig.prodUri : appConfig.onLineProdUri;
			window.open(`${this.exportUrl}${this.activityId}`);

		}
	},
	events:{
		[dropMenuEvent.menu.change](selecObj){
			console.log(selecObj);
			let queryName = selecObj.queryName;
			this[queryName] = selecObj.value;
			this.placeItem = selecObj.text;
		},
		[inputBoxEvent.change](obj){
				let inputName = obj.queryName;
				if(inputName === 'searchInput'){
					this.searchVal = obj.value
				}
		}
	},
	components:{
		pop
	}
}

module.exports = ChargerComment;



// WEBPACK FOOTER //
// ./src/appBackend/components/page/community/activity-topic/apply-list/apply-list.js